import CampaignsPage from './Campaigns';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Action Creators
// import { getCampaigns } from '../../redux/campaigns/actions';
// import { getCardBalance } from '../../redux/loyalty/actions';
import { setLoading } from '../../redux/loading/actions';

// Redux
const mapStateToProps = (state) => {
  const { auth, loyalty } = state;
  return {
    isAuthenticated: ( // returns a boolean
         auth.token === 'undefined'  || auth.token === null
      || auth.userId === 'undefined' || auth.userId === null
      || loyalty.cardNumber === 'undefined' || loyalty.cardNumber === null
    ) ? false : true,
    campaigns: state.campaigns
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // Campaigns
    // getCampaigns,
    // Loyalty
    // getCardBalance,

    // Loading
    setLoading,
  }, dispatch);
}

const ConnectedCampaignsPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CampaignsPage));

export default ConnectedCampaignsPage;



// WEBPACK FOOTER //
// ./src/pages/Campaigns/index.js